import { render, staticRenderFns } from "./addRoleSubmit.vue?vue&type=template&id=13f0fb4c&scoped=true&"
import script from "./addRoleSubmit.vue?vue&type=script&lang=js&"
export * from "./addRoleSubmit.vue?vue&type=script&lang=js&"
import style0 from "./addRoleSubmit.vue?vue&type=style&index=0&id=13f0fb4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f0fb4c",
  null
  
)

export default component.exports